<div class="settings-container">
  <h5>Overall Sounds On/Off</h5>
  <label class="toggle-switch">
    <input type="checkbox" [(ngModel)]="showAlertsSound" (ngModelChange)="onAlertSoundChange()">
    <span class="toggle-slider"></span>
  </label>
  <div style="padding-left: 10px; display: inline-block;">Alert Sound On/Off Control</div>
</div>